export default __webpack_public_path__ + "static/media/A4.c4e2c849.mp3";